module.exports = __webpack_public_path__ + "img/portrait.20827907.png";